import * as React from "react";

export default class Required extends React.Component {
  public render() {
    return <span className="required" />;
  }
}